import type { Ref } from 'react'
import type { LinkProps, To } from 'react-router-dom'
import { createPath, Link, useInRouterContext } from 'react-router-dom'

export type RouterAwareLinkProps = LinkProps & {
  ref?: Ref<HTMLAnchorElement>
}

export function RouterAwareLink({ ref, ...props }: RouterAwareLinkProps) {
  const isInRouterContext = useInRouterContext()
  if (isInRouterContext) {
    return <Link {...props} ref={ref} />
  }

  const { to, ...restProps } = props
  const href = hrefFromTo(to)
  const anchorProps = omitRouterOnlyLinkProps(restProps)

  return (
    <a
      {...anchorProps}
      href={href}
      rel="noopener noreferrer"
      ref={ref}
      target="_blank"
    />
  )
}

function hrefFromTo(to: To): string {
  if (typeof to === 'string') {
    return to
  }

  return createPath(to)
}

function omitRouterOnlyLinkProps({
  defaultShouldRevalidate: _defaultShouldRevalidate,
  discover: _discover,
  mask: _mask,
  prefetch: _prefetch,
  preventScrollReset: _preventScrollReset,
  relative: _relative,
  reloadDocument: _reloadDocument,
  replace: _replace,
  state: _state,
  viewTransition: _viewTransition,
  ...anchorProps
}: Omit<LinkProps, 'to'>) {
  return anchorProps
}
